import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyAE75DhAr5IRn9X2zlKVq9fIwPe1pFX_Mg",
    authDomain: "widgetable-offical.firebaseapp.com",
    projectId: "widgetable-offical",
    storageBucket: "widgetable-offical.appspot.com",
    messagingSenderId: "990984616308",
    appId: "1:990984616308:web:30d63c66c9f84cc7871421",
    measurementId: "G-9ML7D9RLPV"
  };

// 初始化 Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// 导出事件跟踪函数
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== 'undefined') {
    logEvent(analytics, eventName, eventParams);
  }
};

export default app; 